import { selectIsFetching as selectIsFetchingSearch } from './state/search/selector'
import { selectIsFetching as selectIsFetchingDetail } from './state/detail/selector'


export default {
    selector: {
        selectIsFetching: (state) => {
            return selectIsFetchingSearch(state) || selectIsFetchingDetail(state)
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/sales-order/index.js